import React from 'react';

function FaqSupport(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width={52}
      height={52}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={52} height={52} rx={4} fill='#DFD8F3' />
      <mask
        id='mask0_9879_72208'
        style={{
          maskType: 'alpha'
        }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={10}
        width={32}
        height={32}
      >
        <rect x={10} y={10} width={32} height={32} fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_9879_72208)'>
        <path
          d='M40.2554 14.4614C40.3232 14.6091 40.3211 14.696 40.2554 14.884C40.1896 15.0721 38.2833 18.1637 37.8048 18.8585C37.4217 19.4155 36.5445 19.3738 35.6759 19.4812L25.9959 29.1591L23.1665 26.3311L32.85 16.6575C33.0005 15.6799 32.956 14.9505 33.5179 14.5759C34.7386 13.7454 35.9098 12.9749 37.1701 12.2504C37.6189 12.0179 37.8281 11.991 38.2452 12.319C38.6898 12.6696 39.6468 13.6457 40.0179 14.0903C40.1168 14.209 40.1875 14.3136 40.2554 14.4614Z'
          fill='#AF9DE0'
        />
        <path
          d='M13.3139 38.6991C11.5087 36.8939 11.204 34.7161 12.4452 33.475L18.4956 27.8776C17.54 27.1863 18.4193 25.8724 19.3975 26.5544L25.4557 32.6084C26.1378 33.5831 24.8259 34.4659 24.1318 33.5096L18.5147 39.0518C17.2481 40.3184 14.9488 40.3333 13.3139 38.6991ZM18.9989 32.0125C17.3803 33.5046 16.5229 34.3429 14.9516 35.9142C14.3395 36.5263 15.4662 37.6735 16.0889 37.0508L20.1355 33.0049C20.6536 32.3886 19.6265 31.3842 18.9989 32.0125Z'
          fill='#AF9DE0'
        />
        <path
          d='M39.8464 34.4355V35.3876C39.3184 37.7356 37.5549 35.1232 36.7413 34.7069L35.0372 36.3729C35.4061 37.2013 38.0906 38.9783 35.7192 39.5112C32.424 39.8717 29.9487 36.6973 30.7206 33.5908L28.2349 31.0961L31.4248 27.9083L33.9225 30.391C36.6183 29.7231 39.6103 31.546 39.8464 34.4355Z'
          fill='#AF9DE0'
        />
        <path
          d='M16.9262 12.4569C20.2087 12.0724 22.6465 15.3005 21.8838 18.3625L24.6105 21.099L21.4588 24.2868L18.6819 21.563C16.1303 22.1779 13.2988 20.6377 12.8344 17.9433C12.693 17.1785 12.5587 15.4298 13.7858 15.6179C14.2706 15.726 15.3641 17.0025 15.8978 17.2478L17.5652 15.5451C16.9311 14.5873 14.5937 12.8521 16.9262 12.4569Z'
          fill='#AF9DE0'
        />
      </g>
    </svg>
  );
}

FaqSupport.displayName = 'FaqSupport';

export default FaqSupport;
